import './sentry';

// Base scripts
import Alpine from 'alpinejs';
import initCookieBar from './alpine-directives/cookie-bar';
import initCarousels from './carousel';
import initAsyncForms from '../../../app/Plugins/Form/resources/assets/js/main';

// Theme scripts
import initMobileNavigation from './mobile-navigation';
import initNavPopup from './alpine-directives/nav-popup';
import initStringPattern from './string-pattern';

window.addEventListener('DOMContentLoaded', () => {
    initCarousels();
    initMobileNavigation();
    initStringPattern();
    initAsyncForms();

    // If we're using Livewire in this project, we don't need to initialize Alpine.js here.
    // Livewire will do this automatically. To make sure Alpine.js works everywhere, we can include the scripts in the
    // layout file. Docs: https://livewire.laravel.com/docs/installation#manually-including-livewires-frontend-assets
    Alpine.data('initCookieBar', initCookieBar);
    Alpine.data('initNavPopup', initNavPopup);
    Alpine.start();
});
